import { EditCodeEventDialog } from './edit-code-event-dialog';
import { ClipViewerDialogComponent } from './clip-viewer-dialog';
import { AdjustRowTimingsDialog } from './adjust-row-timings-dialog';
import { ExportVideoDialog } from './export-video-dialog';

export const dialogs: any[] = [
  AdjustRowTimingsDialog,
  ExportVideoDialog,
  EditCodeEventDialog,
  ClipViewerDialogComponent
];

export * from './adjust-row-timings-dialog';
export * from './edit-code-event-dialog';
export * from './clip-viewer-dialog';
export * from './export-video-dialog';
